import { z } from 'zod';
import type { TFunction } from 'i18next';
import { cardNumberSchema } from '@/entities/card';

const createCardFormSchema = (t: TFunction) => {
  const required = t('common.requiredField');

  return z.object({
    currencyCode: z.string().nonempty({ message: required }),
    cardNumber: cardNumberSchema(required),
    isCardholderCard: z.boolean().refine(val => val === true, {
      message: required,
    }),
    cardholderName: z.string().nonempty({ message: required }),
    templateName: z.string().nonempty({ message: required }),
  });
};

export { createCardFormSchema };
